import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../redux/userSlice'; // Assuming userSlice is in redux folder
import openCallReducer from '../redux/openCallSlice';
import reviewReducer from '../redux/reviewSlice';
import subscriberReducer from '../redux/subscriberSlice';
import contactFormSubmissionReducer from '../redux/contactFormSubmissionSlice';
import plansReducer from '../redux/planSlice';
import couponReducer from '../redux/couponSlice';
import paymentReducer from '../redux/paymentSlice';
import usersPlansReducer from '../redux/usersPlanSlice';
import logEntriesReducer from '../redux/logEntrySlice';
import emailReducer from '../redux/emailSlice';
import campaignReducer from '../redux/CampaignSlice';
import monthArtistReducer from '../redux/ArtistOfMonthSlice';
import artistInterviewsReducer from '../redux/ArtistInterviewSlice';
import imageUploadReducer from '../redux/ImageUploadSlice';
import invoiceReducer from '../redux/invoiceSlice';
import scraperReducer from '../redux/scraperSlice';
import backgroundTaskLogReducer from '../redux/backgroundTaskLogSlice';
import apiLogReducer from '../redux/apiLogSlice';
import emailEventReducer from './emailEventSlice';
import countryPaymentGatewayReducer from "../redux/countryPaymentGatewaySlice";

export const store = configureStore({
  reducer: {
    users: userReducer,
    opencalls: openCallReducer,  // Using the reducer for open calls
    reviews: reviewReducer,
    subscribers: subscriberReducer,
    contactFormSubmissions: contactFormSubmissionReducer,
    plans: plansReducer,
    coupons: couponReducer,
    payments: paymentReducer,
    usersPlans: usersPlansReducer,
    logEntries: logEntriesReducer,
    email: emailReducer,
    campaigns: campaignReducer,
    monthArtist: monthArtistReducer,
    artistInterviews: artistInterviewsReducer,
    imageUpload: imageUploadReducer,
    invoices: invoiceReducer,
    scraper: scraperReducer,
    backgroundTaskLogs: backgroundTaskLogReducer,
    apiLogs: apiLogReducer,
    emailEvents: emailEventReducer, 
    countryPaymentGateways: countryPaymentGatewayReducer,
    // Add other reducers like organizations here when you implement them
  },
});

export default store;

